export const getSimpleErrorMessage = (response: Record<string, string[]>) => {
  const keys = Object.keys(response);
  if (keys.length) {
    return keys.map((key) => response[key]).join(', ');
  }
  return '';
};
